import { ActionType } from 'src/types/common/common';
import { ResponsivePoster } from 'src/constrains/DraggableModules/Components';
import { dispatch } from '@/src/store';
import { onLoadData } from 'src/constrains/ResponsiveLayerEditor/slice';

const ResponsivePosterFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const handleOnCarouselItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };
  const handleOnCarouselItemReselect = (id, images) => {
    // const _n = optionsToNum[posterType] || 1;
    // const _o = data || [generateResponsiveImage()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: images });
    }
  };

  const handleOnCarouselItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnCarouselStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnCloseAllCollapses = () => {
    if (onCollapseOpen) onCollapseOpen([]);
  };

  const handleOnCarouselModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  const handleOnOpenImageTab = (data) => {
    handleOnCloseAllCollapses();
    setTimeout(() => {
      dispatch(onLoadData(data));
    });
  };

  return {
    handleOnCarouselItemChange,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
    handleOnOpenImageTab,
    handleOnCarouselItemReselect,
  };
};
const generateResponsivePoster = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const {
    handleOnCarouselItemChange,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
    handleOnOpenImageTab,
    handleOnCarouselItemReselect,
  } = ResponsivePosterFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
    onCollapseOpen,
  });
  return {
    component: ResponsivePoster,
    props: {
      onItemChange: handleOnCarouselItemChange,
      onItemSort: handleOnCarouselItemSort,

      onStaticChange: handleOnCarouselStaticChange,
      onModuleTypeChange: handleOnCarouselModuleTypeChange,
      onOpenNewTab: handleOnOpenImageTab,
      onItemReselect: handleOnCarouselItemReselect,
    },
  };
};
export { generateResponsivePoster };
